import { useRouter } from 'next/router'
import cn from 'classnames'
import React, { type ReactElement, useEffect } from 'react'
import Head from 'next/head'
import 'react-toastify/dist/ReactToastify.css'
import { useSnapshot } from 'valtio'
import Breadcrumbs from '../../../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../../../../shared/components/ui/headings/PageHeading'
import { proxyGlobalAuth } from '../../../../../../shared/proxies/proxyGlobalAuth'
import { determineBrowserTabName } from '../../../../../../shared/themes/logoFunctions'
import { rpOccurrenceProxy } from '../rpOccurrenceProxy'
import {
  determineTextColorClassRpOccurrence
} from '../../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/AmountCell/utils'
import { PRETTY_RP_OCCURRENCE_STATUS } from '../../../../../../shared/types/GlobalRPOccurrenceStatuses'
import { APP_RECURRING_PAYMENTS_PATH } from '../../../../../../pages/app/recurring-charges'
import { buildAppRecurringPaymentsPath } from '../../../../../../pages/app/recurring-charges/[id]'
import { executeRecurringTransactionRetrieve } from '../../executeRecurringTransactionRetrieve'
import { executeRpOccurrenceRetrieve } from './utils/executeRpOccurenceRetrieve'
import { RpOccurrenceDetailMainContainer } from './RpOccurrenceDetail/RpOccurrenceDetailMainContainer'
import { RpOccurrenceRelatedTransactionsTable } from './RelatedTransationsTable/RpOccurrenceRelatedTransactionsTable'
import { RpOccurrenceErrorContainer } from './RpOccurrenceDetail/RpOccurrenceErrorContainer'
import { ConfirmResolveModal } from './RpOccurrenceDetail/ResolveModal/ConfirmResolveModal'

export function RpOccurrenceDetailContainer (): ReactElement {
  const router = useRouter()
  const { occurrenceId, id } = router.query
  const { siteTheme: { tableMainColors } } = useSnapshot(proxyGlobalAuth)
  const { rpOccurrence } = useSnapshot(rpOccurrenceProxy)

  useEffect(() => {
    if (!occurrenceId || !id) { return }
    void executeRpOccurrenceRetrieve(occurrenceId as string)
    void executeRecurringTransactionRetrieve(id as string)
  }, [occurrenceId, id])

  if (!rpOccurrence) {
    return (<></>)
  }

  return (
    <>

      <Head>
        <title>{`Recurring Occurrence ${occurrenceId as string} - ${determineBrowserTabName()}`}</title>
      </Head>

      <Breadcrumbs breadcrumbs={[{ path: APP_RECURRING_PAYMENTS_PATH, text: 'Recurring Charges' },
        {
          path: buildAppRecurringPaymentsPath(rpOccurrence.recurringPaymentId),
          text: rpOccurrence.recurringPaymentId
        },
        { text: `Occurrence ${rpOccurrence.id}` }
      ]}
      />

      <PageHeading text="View recurring occurence details and related transactions" />
      <ConfirmResolveModal />
      <div className="flex ">
        <div className="flex flex-row w-full justify-end mb-4">

          <div className={cn('border rounded-full flex items-center justify-center py-1 px-2',
            determineTextColorClassRpOccurrence(rpOccurrence))}
          > {PRETTY_RP_OCCURRENCE_STATUS[rpOccurrence.status]}
          </div>

        </div>
      </div>

      <div className="flex ">

        <div className="flex flex-row justify-between w-full">
          <div className="w-1/2">
            <RpOccurrenceDetailMainContainer />
          </div>
          <div className="w-1/3">
            <RpOccurrenceErrorContainer />
          </div>
        </div>
      </div>
      <div className={cn(tableMainColors.classes, 'bg-white shadow rounded mb-32')}>
        <RpOccurrenceRelatedTransactionsTable />
      </div>

    </>
  )
}
